import { CUSTOM_ELEMENTS_SCHEMA, NgModule, inject } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Bootstrap Modules
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { AlertModule } from 'ngx-bootstrap/alert';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

// Custom Modules & Services
import { BlockService, DemoConfigModule, PageModule, SpinnerModule, UtilsModule } from '@gallaghercp/core-frontend';
import { TranslateModule } from '@ngx-translate/core';
import { SwiperModule } from '@gallaghercp/core-swiper';

// Directives
// Material Modules
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';

// App Components
import { MainComponent } from './main/main.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SideNavComponent } from './nav/side-nav/side-nav.component';
import { SideNavFooterComponent } from './nav/side-nav/side-nav-footer/side-nav-footer.component';
import { TopNavComponent } from './nav/top-nav/top-nav.component';
import { BackToTopComponent } from './back-to-top/back-to-top.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { PostComponent } from './post/post.component';
import { PostThumbnailsComponent } from './nav/top-nav/post-thumbnails/post-thumbnails.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { DarkModeToggleComponent } from './dark-mode-toggle/dark-mode-toggle.component';
import { OopsComponent } from './oops/oops.component';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';

import { LandingComponent } from '@core-app/layout/landing/landing.component';
import { ClientModule } from '../client/client.module';
import { CoroModule } from '@core-app/coro/coro.module';
import { BlockH1TitleComponent } from '@core-app/client/blocks/block-h1-title/block-h1-title.component';

@NgModule({
  declarations: [
    MainComponent,
    MaintenanceComponent,
    OopsComponent,
    HeaderComponent,
    FooterComponent,
    SideNavComponent,
    SideNavFooterComponent,
    TopNavComponent,
    BackToTopComponent,
    NotificationsComponent,
    PostComponent,
    PostThumbnailsComponent,
    DarkModeToggleComponent,
    LandingComponent,
    BlockH1TitleComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    BsDropdownModule,
    CollapseModule,
    ModalModule,
    ButtonsModule,
    CarouselModule,
    TabsModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    SpinnerModule,
    AlertModule,
    TranslateModule,
    MatTabsModule,
    PageModule,
    MatExpansionModule,
    UtilsModule,
    TooltipModule,
    ClientModule,
    SwiperModule,
    DemoConfigModule,
    InfiniteScrollDirective,
    NgOptimizedImage,
    CoroModule,
  ],
  exports: [
    MainComponent,
    CommonModule,
    HeaderComponent,
    NotificationsComponent,
    FooterComponent,
    BackToTopComponent,
    DarkModeToggleComponent,
    SideNavComponent,
    PostThumbnailsComponent,
    LandingComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LayoutModule {
  private blocks = inject(BlockService);

  constructor() {
    this.blocks.addBlock('H1-TITLE', BlockH1TitleComponent);
  }
}
